import WidgetSelect from "./components/Select/WidgetSelect.vue";
import WidgetString from "./components/String/WidgetString.vue";
import WidgetDateTime from "./components/DateTime/WidgetDatetime.vue";

import FormItem from "./components/FormItem/FormItem.vue";
import { required, max, min, regex, minValue } from "@validations";
import _ from "lodash";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { BFormGroup, BFormInput } from "bootstrap-vue";
import { Fragment } from "vue-fragment";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "FormItems",
  props: {
    disabled: Boolean,
    formClass: String,
    formData: {
      type: Object,
      default() {
        return {};
      },
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    numberOfCol: {
      type: Number,
    },
  },
  data() {
    return {
      required,
      max,
      min,
      regex,
    };
  },
  components: {
    Fragment,
    WidgetDateTime,
    WidgetSelect,
    WidgetString,
    ValidationObserver,
    ValidationProvider,
    BFormGroup,
    BFormInput,
    FormItem,
  },
  watch: {
    formData: {
      handler: function (value) {
        console.log(value, "5333");
        if (value) {
          const temp = { ...value };
          this.items.forEach((item) => {
            // handle dateRange value
            if (
              item.rangeData &&
              Array.isArray(item.rangeData) &&
              typeof item.rangeData[0] === "string"
            ) {
              if (temp[item.name]) {
                temp[item.rangeData[0]] = temp[item.name].startDate;
                temp[item.rangeData[1]] = this.formatEndDate(temp[item.name].endDate);
                delete temp[item.name];
                this.$emit("update:formData", temp);
              } else if (
                temp[item.rangeData[0]] &&
                temp[item.rangeData[1]] &&
                !temp[item.name] &&
                typeof temp[item.name] === "object"
              ) {
                delete temp[item.name];
                delete temp[item.rangeData[0]];
                delete temp[item.rangeData[1]];
                this.$emit("update:formData", temp);
              }
            }
          });
        }
      },
      deep: true,
    },
  },
  created() {
    const temp = { ...this.formData };
    this.items.forEach((item) => {
      if (item.type === "date" && item.defaultValue && item.rangeData) {
        item.rangeData.forEach((v, index) => {
          temp[v] = item.defaultValue[index];
        });
      }
    });

    /*     this.$emit("update:formData",temp) */
  },
  methods: {
    updateFormData(name, v) {
      console.log(name, v, "1066");
      this.$emit("update:formData", { ...this.formData, [`${name}`]: v });
      this.$emit("input-change", name, v);
    },
    validate() {
      return this.$refs.observerRef.validate();
    },
  },
  computed: {
    itemsConverted() {
      return this.items?.map((item) => {
        let temp = { ...item };
        const tempRules = { ...item.rules };
        if (item.required) {
          tempRules["required"] = item.required;
          /*  if (item.rules) {
            temp["rules"] = `required|${item.rules}`;
          } */
        }
        if (item.pattern) {
          tempRules["pattern"] = true;
        }

        if (item.customValidate) {
          tempRules["customValidate"] = true;
        }
        if (item.rules) {
          /*  temp["rules"] = item.rules; */
        }
        if (this.disabled) {
          temp["disabled"] = true;
        }
        temp["rules"] = { ...tempRules };
        return temp;
      });
    },
    defaultWrapperClass() {
      return this.numberOfCol ? 12 / this.numberOfCol : "col-6";
    },
  },
});
